import * as React from 'react';
import {authorize, Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {FalconPaymentRequest, ICustomerPortalService, Types, VerifyNewCardResponse, PROCESS_PAY_OFF_BALANCE, ICacheManager} from "@falcon/services";
import {getProductByPolicyNumber, getSessionStorage} from "../../../../../CommonFunctions";
import {Redirect, RouteComponentProps} from "react-router-dom";

interface IPageParams {
    policyNumber: string;
    paymentReference: string;
}

interface IProps extends RouteComponentProps<IPageParams> {
}

interface IState {
   paymentFailed?: boolean;
   paymentCancelled?: boolean;
}

@authorize
export class PayOffBalanceProcessingPage extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    constructor(props: IProps) {
        super(props);

        this.state = {}
    }

    public componentDidMount(): void {
        const policyNumber: string = this.props.match.params.policyNumber;
        const reuseCard: any = getSessionStorage("reuseCard") || false;
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        request.invoiceType = "PAYOFF";
        request.product = getProductByPolicyNumber(policyNumber);

        if (this.props.match.params.paymentReference) {
            this.customerPortalService.payOffBalanceWithNewCard(request, policyNumber, this.props.match.params.paymentReference, reuseCard).subscribe((response: VerifyNewCardResponse) => {

                if (response.successful) {
                    window.sessionStorage.setItem("showPopup", "true");
                    window.sessionStorage.setItem("referrerJourney", PROCESS_PAY_OFF_BALANCE);

                    this.cacheManager.clearCache(`getPolicyPropertyByPropertyKey${policyNumber},mainAnnualPaymentCard`);
                    this.cacheManager.clearCache(`getAnnualPolicyInfo${policyNumber}`);

                    window.location.href = `/dashboard/monthlyPaymentHistory/${policyNumber}`;
                } else if (response.cancelled) {
                    this.setState({
                        paymentCancelled: true
                    })
                } else {
                    this.setState({
                        paymentFailed: true
                    })
                }
            })
        }
    }

    public render(): React.ReactNode {
        if (this.state.paymentFailed) {
            return <Redirect to={{
                pathname: `/dashboard/${this.props.match.params.policyNumber}/payOffBalance/newCard`,
                state: {
                    paymentFailed: this.state.paymentFailed
                }
            }} />
        } else if (this.state.paymentCancelled) {
            return (
                <Redirect to={{
                    pathname: `/dashboard/monthlyPaymentHistory/${this.props.match.params.policyNumber}`
                }} />
            )
        } else {
            return <Overlay show={true}/>
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/payOffBalance/PayOffBalanceProcessingPage.tsx